import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efd3f15e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Riders Earning")
  ])
], -1))
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table table-striped table-sm" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Order No"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Delivery date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total distance"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Peak factor"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Distance amount"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Combo"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Number"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total amount"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Created_at")
  ])
], -1))
const _hoisted_8 = { class: "text-start" }
const _hoisted_9 = { class: "text-start" }
const _hoisted_10 = { class: "text-start" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Riders Wallet")
  ])
], -1))
const _hoisted_21 = { class: "table table-striped table-sm" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Order No"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Item No"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Transaction Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Title"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Created At")
  ])
], -1))
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = { class: "text-start" }
const _hoisted_25 = { class: "text-start" }
const _hoisted_26 = { class: "text-start" }
const _hoisted_27 = { class: "text-start" }
const _hoisted_28 = { class: "text-start" }
const _hoisted_29 = { class: "text-start" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Rider Cancel order Logs")
  ])
], -1))
const _hoisted_33 = { class: "table table-striped table-sm" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Rider Id"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Rider Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Order Id"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Cancel Reason"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Created At")
  ])
], -1))
const _hoisted_35 = { class: "text-start" }
const _hoisted_36 = { class: "text-start" }
const _hoisted_37 = { class: "text-start" }
const _hoisted_38 = { class: "text-start" }
const _hoisted_39 = { class: "text-start" }
const _hoisted_40 = { class: "text-start" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Rider Login Logs ")
  ])
], -1))
const _hoisted_44 = { class: "table table-striped table-sm" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Driver Id"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Driver Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Check In"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Check Out"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Log type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total Minutes"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Created At")
  ])
], -1))
const _hoisted_46 = { class: "text-start" }
const _hoisted_47 = { class: "text-start" }
const _hoisted_48 = { class: "text-start" }
const _hoisted_49 = { class: "text-start" }
const _hoisted_50 = { class: "text-start" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "text-start" }
const _hoisted_53 = { class: "text-start" }
const _hoisted_54 = { class: "text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.riderearnings, (riderearning) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: riderearning.id
                  }, [
                    _createElementVNode("td", _hoisted_8, _toDisplayString(riderearning.id), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(riderearning.order.id), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString($options.dateTime(riderearning.order_delivery_date)), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(riderearning.total_distance) + " " + _toDisplayString(riderearning.order.country.distance_type), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(riderearning.peak_factor), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(riderearning.order.country.currency_short_name) + _toDisplayString(riderearning.distance_amount), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(riderearning.order.combine_order_id), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(riderearning.order.combine_order_number), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(riderearning.order.country.currency_short_name) + _toDisplayString(riderearning.total_amount), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString($options.dateTime(riderearning.created_at)), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.page,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => ($setup.load($event)))
      ],
      pages: $setup.lastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"]),
    _hoisted_18,
    _hoisted_19,
    _hoisted_20,
    _createElementVNode("table", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.riderwallets, (riderwallet) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: riderwallet.id
          }, [
            _createElementVNode("td", _hoisted_23, _toDisplayString(riderwallet.id), 1),
            _createElementVNode("td", _hoisted_24, _toDisplayString(riderwallet.order?.id), 1),
            _createElementVNode("td", _hoisted_25, _toDisplayString(riderwallet.orderitem?.id), 1),
            _createElementVNode("td", _hoisted_26, _toDisplayString(riderwallet.transaction_type), 1),
            _createElementVNode("td", _hoisted_27, _toDisplayString(riderwallet.country?.currency_short_name) + _toDisplayString(riderwallet.amount), 1),
            _createElementVNode("td", _hoisted_28, _toDisplayString(riderwallet.title), 1),
            _createElementVNode("td", _hoisted_29, _toDisplayString($options.dateTime(riderwallet.created_at)), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.rwpage,
      "onUpdate:modelValue": [
        _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rwpage) = $event)),
        _cache[3] || (_cache[3] = ($event: any) => ($setup.rwload($event)))
      ],
      pages: $setup.rwlastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"]),
    _hoisted_30,
    _hoisted_31,
    _hoisted_32,
    _createElementVNode("table", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ridercancelorderlogs, (ordercancellog) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: ordercancellog.id
          }, [
            _createElementVNode("td", _hoisted_35, _toDisplayString(ordercancellog.id), 1),
            _createElementVNode("td", _hoisted_36, _toDisplayString(ordercancellog.driver.id), 1),
            _createElementVNode("td", _hoisted_37, _toDisplayString(ordercancellog.driver.rider_name), 1),
            _createElementVNode("td", _hoisted_38, _toDisplayString(ordercancellog.order.id), 1),
            _createElementVNode("td", _hoisted_39, _toDisplayString(ordercancellog.cancel_reason), 1),
            _createElementVNode("td", _hoisted_40, _toDisplayString($options.dateTime(ordercancellog.created_at)), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.rwpage,
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.rwpage) = $event)),
        _cache[5] || (_cache[5] = ($event: any) => ($setup.rwload($event)))
      ],
      pages: $setup.rwlastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"]),
    _hoisted_41,
    _hoisted_42,
    _hoisted_43,
    _createElementVNode("table", _hoisted_44, [
      _hoisted_45,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.riderloginlogs, (driverloginlog) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: driverloginlog.id
          }, [
            _createElementVNode("td", _hoisted_46, _toDisplayString(driverloginlog.id), 1),
            _createElementVNode("td", _hoisted_47, _toDisplayString(driverloginlog.driver.id), 1),
            _createElementVNode("td", _hoisted_48, _toDisplayString(driverloginlog.driver.rider_name), 1),
            _createElementVNode("td", _hoisted_49, _toDisplayString($options.dateTime(driverloginlog.in_datetime)), 1),
            _createElementVNode("td", _hoisted_50, [
              (driverloginlog.out_datetime)
                ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString($options.dateTime(driverloginlog.out_datetime)), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_52, _toDisplayString(driverloginlog.log_type), 1),
            _createElementVNode("td", _hoisted_53, _toDisplayString(driverloginlog.time_in_minutes), 1),
            _createElementVNode("td", _hoisted_54, _toDisplayString($options.dateTime(driverloginlog.created_at)), 1)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.rwpage,
      "onUpdate:modelValue": [
        _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rwpage) = $event)),
        _cache[7] || (_cache[7] = ($event: any) => ($setup.rwload($event)))
      ],
      pages: $setup.riderloginlastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"])
  ], 64))
}